import { useEffect } from 'react'
import { useUser } from './user'
import { useDB } from '@/lib/db-context'

export let dbVersion = 0

export function useProfileDB() {
  const currentProfileId = useUser((c) => c.profileId) as string
  const ctx = useDB(currentProfileId || 'main')

  useEffect(() => {
    // @ts-expect-error This is just for debugging
    window.q = (...q: any[]) => ctx.db.execO(...q).then(console.log)

    if (!ctx.db) {
      return
    }

    const unsub = ctx.db.onUpdate(() => {
      dbVersion++
    })

    return () => {
      unsub()
    }
  }, [currentProfileId, ctx.db])

  return ctx
}
